/**
 * Wheel-zoom step for OrbitControls, in view-radius units.
 *
 * Must stay proportional to the current radius (~10% per tick). A constant
 * world-unit step (the old `3.14 / radius` cancellation) makes site-scale
 * ortho panes in Cloud Alignment effectively un-zoomable.
 *
 * InputHandler / MultiViewInputHandler normally pass ±1. Magnitude is ignored
 * so a raw pixel `deltaY` cannot jump by tens of radii in one tick.
 *
 * @param {number} resolvedRadius  view.radius + pending radiusDelta
 * @param {number} wheelDelta      + scroll-up (zoom in) / − scroll-down (zoom out)
 * @param {boolean} [scrollEnabled=true]
 * @returns {number} additive radiusDelta for this tick (does not include the pending delta)
 */
export function orbitWheelZoomDelta(
  resolvedRadius,
  wheelDelta,
  scrollEnabled = true,
) {
  if (!scrollEnabled) return 0;

  const direction = Math.sign(-wheelDelta);
  if (direction === 0) return 0;
  // Zoom-in from a collapsed / inverted radius is blocked; zoom-out can escape.
  if (resolvedRadius <= 0 && direction < 0) return 0;

  if (resolvedRadius < 0.001) {
    return direction * 0.5;
  }
  return direction * resolvedRadius * 0.1;
}
